import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { MerchantRentalRentPage } from './merchant-rental-rent';

@NgModule({
  declarations: [
    MerchantRentalRentPage,
  ],
  imports: [
    IonicPageModule.forChild(MerchantRentalRentPage),
    TranslateModule.forChild()
  ],
})
export class MerchantRentalRentPageModule {}



// WEBPACK FOOTER //
// ./src/pages/merchant-rental-rent/merchant-rental-rent.module.ts